const Dashboard = () => {
    return (
        <>
            {/* <p className='Help__Title'>Ayuda</p> */}
        </>
    )
}

export { Dashboard };